import { render, staticRenderFns } from "./merchantPayMoreList.vue?vue&type=template&id=5b635b79"
import script from "./merchantPayMoreList.vue?vue&type=script&lang=js"
export * from "./merchantPayMoreList.vue?vue&type=script&lang=js"
import style0 from "./merchantPayMoreList.vue?vue&type=style&index=0&id=5b635b79&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports